// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class DateFormatService {

  private readonly inputFormat = 'YYYY-MM-DD';

  formatLabel(key: string) {
    if (key.length === 10) {
      return this.formatDate(key);
    }

    const separator = ' - ';
    const dates = key.split(separator);
    const momentDates = dates.map(date => this.convertToMoment(date));

    const startOfMonth = momentDates[0].startOf('month').format(this.inputFormat);
    const endOfMonth = momentDates[0].endOf('month').format(this.inputFormat);
    if (startOfMonth === dates[0] && endOfMonth === dates[1]) {
      return this.formatMonthlyDate(momentDates[0]);
    }

    return dates.map(date => this.formatDate(date)).join(separator);
  }

  private convertToMoment(date: string): moment.Moment {
    return moment(date, this.inputFormat);
  }

  private formatDate(date: string): string {
    return moment(date, this.inputFormat).format('ddd, MMM DD');
  }

  private formatMonthlyDate(date: moment.Moment): string {
    return date.format('MMMM YYYY');
  }

}
